<template lang="html">
  <div class="wrapper">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.wrapper {
  border-radius: 12px;
  box-shadow: $shadow-card;
  padding: 1rem;
  color: $color-text-primary;
}

@media (prefers-color-scheme: dark) {
  .wrapper {
    background-color: $color-background-secondary-dark;
    color: $color-text-primary-dark;
  }
}
</style>
